<template>
  <state-pension-viewer></state-pension-viewer>
  <pension-pots-viewer
    v-if="showPensionPots"
    :title="pensionPotsViewerTitle"
    @guaranteed-income-change-required="$emit('guaranteed-income-change-required')"
  ></pension-pots-viewer>
  <final-salary-assets-viewer v-if="showFinalSalary"></final-salary-assets-viewer>
  <savings-viewer v-if="showSavings"></savings-viewer>
  <other-cash-viewer v-if="showOtherCash"></other-cash-viewer>
  <other-income-viewer v-if="showOtherIncome"></other-income-viewer>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import StatePensionViewer from "@/guiide/components/assets/StatePensionViewer.vue";
import PensionPotsViewer from "@/guiide/components/assets/PensionPotsViewer.vue";
import FinalSalaryAssetsViewer from "@/guiide/components/assets/FinalSalaryAssetsViewer.vue";
import OtherIncomeViewer from "@/guiide/components/assets/OtherIncomeViewer.vue";
import OtherCashViewer from "@/guiide/components/assets/OtherCashViewer.vue";
import SavingsViewer from "@/guiide/components/assets/SavingsViewer.vue";

export default defineComponent({
  name: "Dashboard",
  emits: ["guaranteed-income-change-required"],
  components: {
    StatePensionViewer,
    PensionPotsViewer,
    FinalSalaryAssetsViewer,
    OtherIncomeViewer,
    OtherCashViewer,
    SavingsViewer,
  },
  computed: {
    showPensionPots: function(): boolean {
      return this.$store.state.configuration.assetOptions.pensionPots;
    },
    showFinalSalary: function(): boolean {
      return this.$store.state.configuration.assetOptions.finalSalary;
    },
    showSavings: function(): boolean {
      return this.$store.state.configuration.assetOptions.savings;
    },
    showOtherCash: function(): boolean {
      return this.$store.state.configuration.assetOptions.otherCash;
    },
    showOtherIncome: function(): boolean {
      return this.$store.state.configuration.assetOptions.otherIncome;
    },
    pensionPotsViewerTitle: function(): string {
      return this.$store.state.configuration.havesPensionPotsListHeaderText;
    }
  }
});
</script>
